import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import SvgShows from '../../../../../play-core/icons/Shows';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { usePath } from '../../../config/VideoAppContext';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { aspectRatioMap } from '../../Image/PlayImage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionDetailTeaser = ({
  aspectRatio,
  section
}) => {
  const {
    sectionDetailPath
  } = usePath();
  const {
    t
  } = useTranslation();
  const representation = {
    title: ' ',
    ...section.representation
  };
  return /*#__PURE__*/_jsx(StyledLink, {
    to: sectionDetailPath({
      ...section,
      representation
    }),
    children: /*#__PURE__*/_jsx(Layout, {
      aspectRatio: aspectRatio,
      children: /*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsx(IconWrapper, {
          icon: /*#__PURE__*/_jsx(SvgShows, {}),
          size: 40,
          color: Colors.GREY_d2d2d2
        }), /*#__PURE__*/_jsx(Text, {
          children: t('global.moreVideos')
        })]
      })
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "SectionDetailTeaser__Layout",
  componentId: "sc-1pxdsps-0"
})(["position:relative;background-color:", ";border-radius:2px;padding-top:", ";height:auto;&:hover{background-color:", ";}"], Colors.GREY_2a2a2a, ({
  aspectRatio
}) => `${100 / aspectRatioMap[aspectRatio]}%`, Colors.GREY_3a3a3a);
const Text = styled.span.withConfig({
  displayName: "SectionDetailTeaser__Text",
  componentId: "sc-1pxdsps-1"
})(["", ";color:", ";margin-top:12px;"], Fonts.regular(22), Colors.GREY_d2d2d2);
const StyledLink = styled(Link).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "SectionDetailTeaser__StyledLink",
  componentId: "sc-1pxdsps-2"
})([""]);
const Content = styled.div.withConfig({
  displayName: "SectionDetailTeaser__Content",
  componentId: "sc-1pxdsps-3"
})(["position:absolute;height:100%;width:100%;top:0;display:flex;align-items:center;flex-direction:column;justify-content:center;"]);